module.exports = __webpack_public_path__ + "static/img/tp_logo.177ad0e0.png";